import { useCallback, useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';

import * as Actions from 'flex/Actions';
import { useAppSelector } from 'flex/utils';

type GetSettingsState = {
    isLoading: boolean,
    data?: Payload['result']
};

type Meta = SecurityGetSettingsConnection['meta'];
type Payload = SecurityGetSettingsConnection['payload'];

/**
 * セキュリティ設定全体 取得フック
 * control/security/setting エンドポイントへ GET する
 */
export const useGetSettings = (
    successCallback: (meta: Meta, payload: Payload) => void = () => undefined,
    failureCallback: (meta: Meta, payload: Payload) => void = () => undefined,
) => {
    const [state, setState] = useState<GetSettingsState>({
        isLoading: false,
        data: undefined,
    });

    const securityGetSettingsConnection = useAppSelector(state => state.securityGetSettingsConnection);

    const dispatch = useDispatch();

    useEffect(() => {
        const { meta, payload } = securityGetSettingsConnection;

        // 通信中でない === 画面遷移など意図しないタイミング
        if (!state.isLoading) return;

        switch (meta.status) {
            case Actions.statusEnum.SUCCESS: {
                successCallback(meta, payload);
                setState(prev => ({ 
                    ...prev,
                    data: payload.result,
                    isLoading: false
                }));
                return;
            }
            case Actions.statusEnum.FAILURE:
            case Actions.statusEnum.ERROR: {
                failureCallback(meta, payload);
                setState(prev => ({ ...prev, isLoading: false }));
                return;
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [securityGetSettingsConnection]);

    const request = useCallback(() => {
        dispatch(Actions.http.connection.security.getSettings());
        setState(prev => ({ ...prev, isLoading: true }));
    }, [dispatch]);

    return [state, request] as const;
};
